import React, { Component } from "react";
import styled, { css } from "styled-components";

const LedContainer = styled.div`
  width: calc(100% / 32);
  height: calc(100% / 32);
  position: relative;
  display: block;
  background: #fff;
  border-radius: 15%;
`;

const LedElement = styled.div<{ showBorders: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: block;
  cursor: pointer;
  ${({ showBorders }) =>
    showBorders &&
    css`
      box-shadow: inset 0 0 0 1px hsl(240, 3%, 6%);
    `}
`;

interface Props {
  color: string;
  index: number;
  showBorders: boolean;
  handleClick: (index: number) => void;
  handleMouseEnter: (index: number) => void;
  handleMouseDown: (index: number) => void;
  handleMouseUp: (index: number) => void;
}

export default class Led extends Component<Props> {
  shouldComponentUpdate(nextProps) {
    // Don't update if the color hasn't changed
    // Decreases browser scripting time by 10x on click
    if (this.props.color !== nextProps.color || this.props.showBorders !== nextProps.showBorders) {
      return true;
    }
    return false;
  }

  render() {
    let background = this.props.color;

    return (
      <LedContainer>
        <LedElement
          onClick={() => this.props.handleClick(this.props.index)}
          onMouseEnter={() => this.props.handleMouseEnter(this.props.index)}
          onMouseDown={() => this.props.handleMouseDown(this.props.index)}
          onMouseUp={() => this.props.handleMouseUp(this.props.index)}
          style={{ background }}
          showBorders={this.props.showBorders}
        />
      </LedContainer>
    );
  }
}
